import * as React from 'react';
import { ConfigProvider, Divider, Drawer, Empty, Input, Modal, Progress, Row, Spin, Table, } from 'antd';

import { L } from '../../../../lib/abpUtility';
import { SmallDashOutlined, LoadingOutlined, BookOutlined } from '@ant-design/icons';
import TemplateSelectCard from '../../Views/Cards/templateSelectCard';


export interface ITemplateChooserProps {

    loading: boolean;
    isMobile: boolean;
    entityStore: any;
    primaryColor: string;
    secondaryColor: string;
    dataTableImage: any;
    dataTableText: string;
    search_Mentions: any;
    search_Hashtags: any;
    visible: boolean;

    getProfileImage: (id: any) => any;
    handleSearch: (value: string) => void;
    onCreate: (values: any, title: any) => void;
    onCancel: () => void;
}

export interface ITemplateChooserBaseState {
    itemCreateDrawerOpen: boolean;
    stateCreateDrawerOpen: boolean;
    optionCreateDrawerOpen: boolean;

    defaultItemImage: string;
    itemProfileID: number;
    defaultStateImage: string;
    stateProfileID: number;
    prefix: any;

    tableSize: any;
    searchMargin: any;
    formSize: any;
    currentSearchValue: string;
}

class TemplateChooser extends React.Component<ITemplateChooserProps, ITemplateChooserBaseState> {

    state =
        {
            formSize: '',
            searchSize: '220px',
            tableSize: '95%',
            searchMargin: '15px',
            prefix: '@',
            itemCreateDrawerOpen: false,
            stateCreateDrawerOpen: false,
            optionCreateDrawerOpen: false,
            defaultItemImage: '',
            itemProfileID: 0,
            defaultStateImage: '',
            stateProfileID: 0,
            currentSearchValue: ''
        };

    async componentDidMount() {

        if (window.innerWidth >= 550) {

            if (window.innerWidth >= 800) {
                this.setState({
                    searchMargin: '0'
                });
            }
            else {
                this.setState({
                    searchMargin: '0'
                });
            }

            this.setState({

                tableSize: (window.innerWidth * 0.85).toString() + 'px',
                formSize: (window.innerWidth * 0.85).toString() + 'px',

            });
        }
        else {
            this.setState({

                tableSize: (window.innerWidth * 0.80).toString() + 'px',
                formSize: (window.innerWidth * 0.80).toString() + 'px',
                searchMargin: '0'
            });
        }

        window.addEventListener('resize', this.handleResize);
    }

    handleResize = () => {


        if (window.innerWidth >= 550) {

            if (window.innerWidth >= 800) {
                this.setState({
                    searchMargin: '0'
                });
            }
            else {
                this.setState({
                    searchMargin: '0'
                });
            }

            this.setState({

                tableSize: (window.innerWidth * 0.85).toString() + 'px',
                formSize: (window.innerWidth * 0.85).toString() + 'px',
            });
        }
        else {
            this.setState({

                tableSize: (window.innerWidth * 0.80).toString() + 'px',
                formSize: (window.innerWidth * 0.80).toString() + 'px',
                searchMargin: '0'
            });
        }

    }

    handleCancel = () => {
        this.props.onCancel();
    }

 
    onSearch = (_: any, prefix: any) => {
        this.setState({ currentSearchValue: _ })
    };

    render() {


        const templateChooserColumns = [
            {
                title: L('Templates'), dataIndex: 'templateChooser', key: 'templateChooser', style: { backgroundColor: 'black' },
                render: (text: string, item: any) => {
                    return {
                        props: {
                            style: { paddingTop: '2px', paddingBottom: '10px', }
                        },
                        children: <div className="font-face-gm">
                            <TemplateSelectCard
                                tinyReports={[]}
                                profileImageID={item.profileImageID}
                                defaultIcon={<BookOutlined twoToneColor={this.props.secondaryColor} style={{ fontSize: 30, padding: '3px' }} />}
                                id={item.id}
                                primaryColor={this.props.primaryColor}
                                secondaryColor={this.props.secondaryColor}
                                title={item.name}
                                subTitle={item.title}
                                cardSelect={() => this.props.onCreate(item.id, item.name)}
                                getProfileImage={() => this.props.getProfileImage(item.profileImageID)}
                            />
                        </div>
                    };
                }
            },
        ];

        const { visible, isMobile } = this.props;
        const { Search } = Input;


        return (

            <div className="font-face-gm" style={{overflow: 'hidden'}}>

                <div>
                    <Modal
                        closable={this.props.isMobile === true ? true : false}
                        visible={isMobile === false ? (visible === true ? true : false) : false}
                        cancelText={L('Cancel')}
                        onCancel={this.handleCancel}  
                        footer={null}
                        title={null}>

                        <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                            {L('Select Template')}
                        </Divider>
                        <Row style={{ marginBottom: '0px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>
                        <div className="font-face-gm" style={{
                            margin: 'auto', float: 'none', width: this.state.tableSize,
                            maxWidth: '400px', marginBottom: '25px', textAlign: 'center'
                        }}>
                            <Search onSearch={this.onSearch} placeholder={L('Search')} style={{ width: 250 }} />
                        </div>
                        <div style={{
                            margin: 'auto', float: 'none', width: this.state.tableSize,
                            maxWidth: '400px',
                        }}>

                            <ConfigProvider renderEmpty={() =>
                                <Empty

                                    image={
                                        this.props.loading === true ?
                                            (<SmallDashOutlined />) :

                                            (this.props.dataTableImage)}
                                    imageStyle={{
                                        height: 60,
                                    }}
                                    description={
                                        <span>
                                            {this.props.dataTableText}
                                        </span>
                                    }
                                />}>


                                <Table
                                    //rowKey={record => record.id.toString()}\
                                    style={{ backgroundColor: 'transparent' }}
                                    size={'small'}
                                    showHeader={false}
                                    bordered={false}
                                    columns={templateChooserColumns}
                                    pagination={{ pageSize: 6, total: this.props.entityStore.entityTemplateSummary === undefined ? 0 : this.props.entityStore.entityTemplateSummary.length, defaultCurrent: 1 }}
                                    loading={this.props.loading === true ? { indicator: <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: this.props.primaryColor }} spin />} /> } : false}
                                    dataSource={
                                        this.state.currentSearchValue === '' ?
                                            this.props.entityStore.entityTemplateSummary === undefined ? [] : this.props.entityStore.entityTemplateSummary.items
                                            :
                                            this.props.entityStore.entityTemplateSummary === undefined ? [] : this.props.entityStore.entityTemplateSummary.items.filter((x: any) => x.name.toLowerCase().includes(this.state.currentSearchValue.toLowerCase() || x.title.toLowerCase().includes(this.state.currentSearchValue.toLowerCase())))

                                    }
                                />





                            </ConfigProvider>

                        </div>


                    </Modal>
                </div>
 
                <div>
                    <Drawer
                        closable={this.props.isMobile === true ? true : false}
                        onClose={this.handleCancel}
                        closeIcon={false}
                        visible={isMobile === true ? (visible === true ? true : false) : false}

                        width={window.innerWidth < 600 ? (window.innerWidth * 0.9) : 430}  >

 

                            <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2.3em', marginBottom: '0px', margin: 'auto' }} >
                                {L('Select Template')}
                            </Divider>
                            <Row style={{ marginBottom: '0px', margin: 'auto' }}>
                                <Progress
                                    strokeColor={{
                                        from: this.props.secondaryColor,
                                        to: this.props.primaryColor,
                                    }}
                                    showInfo={false}
                                    percent={100}
                                    status="normal"
                                    size={'small'}
                                />
                            </Row>

                            <div className="font-face-gm" style={{
                                margin: 'auto', float: 'none', 
                                maxWidth: '400px', marginBottom: '25px', textAlign: 'center'
                            }}>
                                <Search onSearch={this.onSearch}   placeholder={L('Search')} style={{ width: 320, margin: 'auto' }} />
                            </div>

                            <div style={{
                                margin: 'auto', float: 'none', width: this.state.tableSize,
                                maxWidth: '360px',
                            }}>

                                <ConfigProvider renderEmpty={() =>
                                    <Empty

                                        image={
                                            this.props.loading === true ?
                                                (<SmallDashOutlined />) :

                                                (this.props.dataTableImage)}
                                        imageStyle={{
                                            height: 60,
                                        }}
                                        description={
                                            <span>
                                                {this.props.dataTableText}
                                            </span>
                                        }
                                    />}>

                                    <Table
                                        //rowKey={record => record.id.toString()}\
                                        style={{ backgroundColor: 'transparent' }}
                                        size={'small'}
                                        showHeader={false}
                                        bordered={false}
                                        columns={templateChooserColumns}
                                        pagination={{ pageSize: 6, total: this.props.entityStore.entityTemplateSummary === undefined ? 0 : this.props.entityStore.entityTemplateSummary.length, defaultCurrent: 1 }}
                                        loading={this.props.loading === true ? { indicator: <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: this.props.primaryColor }} spin />} /> } : false}
                                        dataSource={

                                            this.state.currentSearchValue === '' ?
                                                this.props.entityStore.entityTemplateSummary === undefined ? [] : this.props.entityStore.entityTemplateSummary.items
                                                :
                                                this.props.entityStore.entityTemplateSummary === undefined ? [] : this.props.entityStore.entityTemplateSummary.items.filter((x: any) => x.name.toLowerCase().includes(this.state.currentSearchValue.toLowerCase() || x.title.toLowerCase().includes(this.state.currentSearchValue.toLowerCase())))



                                        }

                                    />


                                </ConfigProvider>

                            </div>

 

                    </Drawer>
                </div>

            </div>
        );
    }
}

export default TemplateChooser;
